<template>
    <div id="head-navbar-detail" class="bg-golden">
        <div id="bg-green-curve" class="bg-green m-auto">
            <div class="nv-wrapper">
                <div>
                    <div class="nv-l">
                        <div>
                            <img class="nv-back" @click="clickBack" src="@/assets/image/Navbar/img_icon_navbar.png" alt="">
                        </div>
                        <div class="nv-name">{{navName}}</div>
                    </div>
                </div>
                <div>
                    <div class="nv-r" :class="{'nv-r-news': !isShowInfo}">
                        <div class="nv-user-info" v-if="isShowInfo">
                            <div class="nv-user-name-txt">{{ lbl.navbar_title }}</div>
                            <div class="nv-user-point-txt" :class="{'long-point': userPoint.toString().length >= 4 }">{{ userPoint | number_format }}</div>
                            <div class="nv-user-name-txt">{{ lbl.nav_point }}</div>
                        </div>
                        <div  v-if="isShowCart"  @click="goShoppingCartProduct()">
                            <img class="cart img-fluid" src="../../../assets/icon/newversion/cart.svg" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <cookie-consent-bar></cookie-consent-bar> -->
    </div>
</template>
<script>
import Vue from 'vue';
import Util from '@/helper/Utility.js';
import BzbsAuth from '@/core/Account/service/BzbsAuth.js';
import { AccessKeyModel } from '@/core/Account/model/AccessKeyModel.js';
import AccountMixin from "@/mixin/AccountMixin.js";
// import CookieConsentBar from '../../../components/Layout/CookieConsentBar/CookieConsentBar.vue';
export default {
    name: 'navbar-detail',
    props: {
        lbl: Object,
        isShowInfo: Boolean,
        navName: String,
        userType: String,
        userPoint: Number,
        busNav: Object,
        isShowCart:Boolean
    },
    mixins: [
        AccountMixin,

    ],
    components: {
        // CookieConsentBar
    },
    data: function(){
        return{
            config: Vue.bzbsConfig,
        }
    },
    methods: {
        //Event
        clickBack: function () {
            this.$emit('clickBack');
        },
        //utile
        pointFormat: function () {
            var point = Util.formatNum(this.userPoint);
            return Util.stringFormat(this.lbl.navbar_point, point);
        },
        getShoppingCartAccessKey: function(token) {
            return new Promise((resolve) => {
                let currentUrl = window.location.href
                let payload = {
                    returnUrl: currentUrl,
                    successUrl: currentUrl,
                    errorUrl: currentUrl,
                    appId: this.config.client_id,
                    appName: this.config.appname,
                    routeMode: 'push',
                }
                let jsonPayload = JSON.stringify(payload)
                BzbsAuth.apiCreateAccessKey(token, jsonPayload)
                    .then(res => {
                        let accessKey = new AccessKeyModel()
                        accessKey.setDataFromApi(res.data.data)
                        resolve(accessKey.accessKey);
                    }).catch(err => {
                        console.log(err);
                        resolve(null);
                    });
            })
        },
        checkConsentCookie: async function  () {
            const token = this.getToken();
            const currentVersion = await this.getCurrentVersion();
            const userConsent = await this.getUserConsent(token);

            if (currentVersion && userConsent) {
                this.currentVersion = currentVersion.data.cookie.current_version;
                this.userConsent = userConsent;

                if (this.currentVersion != userConsent.NecessaryCookies ||
                    this.currentVersion != userConsent.FunctionalCookies) {
                    this.showCookieModals();
                }
            }
        },
        goShoppingCartProduct: async function() {
            console.log('goShoppingCartProduct');
            let token = this.getToken();
            let accessKey = await this.getShoppingCartAccessKey(token)

            if (accessKey == null) {
                return
            }

            let appName = this.config.appname;
            let url = this.config.bzbNewShoppingCartUrl + `/landing/${appName}?access_key=${accessKey}&appname_config=${appName}`
            window.location.href = url
        },
    }
}
</script>
<style lang="scss">
@import "./NavBarDetail.scss";
</style>
